import React, { FC, PropsWithChildren } from 'react';
import Hidden from '@/components/Hidden';
import { TopContentPortal as BaseTopContentPortal } from '@/layouts/Base/components/TopContent';

interface ITopContentPortalProps {}

const TopContentPortal: FC<PropsWithChildren<ITopContentPortalProps>> = ({
  children,
}) => {
  return (
    <>
      <Hidden down="md">
        <BaseTopContentPortal>
          <div className="mb-[18px]">{children}</div>
        </BaseTopContentPortal>
      </Hidden>
      <Hidden up="md">
        <div className="mb-[24px]">{children}</div>
      </Hidden>
    </>
  );
};

export default TopContentPortal;
